<template>
  <ui-dialog
    class="cms-html-editor-toolbar-preview"
    :open.sync="isOpen"
    :title="$t('HtmlEditorToolbarPreview.preview')"
    :closeScrim=false>
    <template #contents>
      <div v-html="value" class="foo"></div>
    </template>
    <template #footer>
      <button
        type="button"
        class="ui-native --main"
        @click="onAccept"
      >{{ $t('HtmlEditorToolbarPreview.accept') }}</button>
    </template>
  </ui-dialog>
</template>

<script>
import { UiDialog } from '@/modules/ui/components';

import useI18n from '@/modules/i18n/mixins/useI18n.js';
export default {
  components: {
    UiDialog,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  mixins: [useI18n],
  methods: {
    onAccept() {
      this.$emit('close');
    },
  },
  i18n: {
    en: {
      'HtmlEditorToolbarPreview.accept': 'Accept',
      'HtmlEditorToolbarPreview.preview': 'Preview',

    },
    es: {
      'HtmlEditorToolbarPreview.accept': 'Aceptar',
      'HtmlEditorToolbarPreview.preview': 'Previsualizar',
    },
    de: {
      'HtmlEditorToolbarPreview.accept': 'Akzeptieren',
      'HtmlEditorToolbarPreview.preview': 'Vorschau',
    },
  },
}
</script>

<style lang="scss">
.cms-html-editor-toolbar-preview {
  code {
    color: #fff;
    background-color: #0D0D0D;
  }

  pre {
    color: #fff;
    background: #0D0D0D;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      padding: 0;
      color: inherit;
      background: none;
      font-size: 0.8rem;
    }
  }

  a {
    color: blue;
    text-decoration: underline;
  }

  table {
    margin: 0;
    width: 100%;
    overflow: hidden;
    table-layout: fixed;
    border-collapse: collapse;

    td,
    th {
      min-width: 1em;
      padding: 3px 5px;
      position: relative;
      vertical-align: top;
      box-sizing: border-box;
      border: 2px solid #ced4da;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      text-align: left;
      font-weight: bold;
      background-color: #f1f3f5;
    }

    .selectedCell:after {
      z-index: 2;
      content: "";
      position: absolute;
      pointer-events: none;
      left: 0; right: 0; top: 0; bottom: 0;
      background: rgba(200, 200, 255, 0.4);
    }

    .column-resize-handle {
      top: 0;
      width: 4px;
      right: -2px;
      bottom: -2px;
      position: absolute;
      pointer-events: none;
    }

    p {
      margin: 0;
    }
  }

  figure {
    &.ProseMirror-selectednode img {
      outline: 2px solid #9c9c9c;
    }
  }
}
</style>